export default class vendor_servicing_pricing {
  constructor() {
    this.BronzeDisplayPrice = $("#BronzeDisplayPrice");
    this.SilverDisplayPrice = $("#SilverDisplayPrice");

    this.GoldDisplayPrice = $("#GoldDisplayPrice");

    //   this.addRs = $("#addRs");
    //   this.addMoneyButton = $("#addMoneyButton");
    //   this.AddRsError = $("#AddRsError");

    this.bindEvents();
  }

  bindEvents = () => {
    this.getActiveSubscription();
    this.getSubscriptionPricing();
    //   this.addMoneyButton.on("click", this.validateInputMoney);

    //New Functions for cashFree
    $(".SponsoredPay").on("click", this.makeCashfreePayment);

    //To check if a subscription is Expiring soon and send an Email to vendor
    this.checkIfSubscriptionExpiring();
  };

  getActiveSubscription = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/GetActiveSubscription",

      headers: { Authorization: X_API_KEY },
      success: this.showActiveSubscription,
    });
  };

  showActiveSubscription = (res) => {
    if (res && res !== "false") {
      // Ensure res is an array
      const data = Array.isArray(res) ? res : [res];
      var sponsorRow = ``;
      data.forEach((element) => {
        if (element && element.Promotion_Duration) {
          sponsorRow = `${sponsorRow}<div class="col-4 text-center"><label>Duration:<span class="subDuration">${element.Promotion_Duration}</span> months</label></div>
                            <div class="col-4 text-center"><span class="subStartDate">${element.Start_date}</span></div>
                            <div class="col-4 text-center"><span class="subEndDate">${element.End_date}</span></div>`;
        }
      });

      var ActiveSubBox = document.getElementsByClassName("ActiveSubBox")[0];
      if (ActiveSubBox) {
        var item = `<div class="row">
      <div class="col-12">
          <h5>Current Subscriptions</h5>
      </div>
      <div class="col-4 text-center">Duration:</div>
      <div class="col-4 text-center">Start Date:</div>
      <div class="col-4 text-center">Expiry Date:</div>
      ${sponsorRow}
      </div>`;

        ActiveSubBox.innerHTML = item;
      }
    }
  };

  getSubscriptionPricing = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/vendor/GetSubscriptionPricing",

      headers: { Authorization: X_API_KEY },
      success: this.showSubscriptionPricing,
    });
  };

  showSubscriptionPricing = (res) => {
    if (res && Array.isArray(res)) {
      this.BronzeDisplayPrice.html(res[0]?.Picklist_display_value || "0");
      this.SilverDisplayPrice.html(res[1]?.Picklist_display_value || "0");
      this.GoldDisplayPrice.html(res[2]?.Picklist_display_value || "0");

      var payBtns = document.getElementsByClassName("SponsoredPay");
      for (var i = 0; i < Math.min(payBtns.length, res.length); i++) {
        payBtns[i].value = res[i].extra_value || "";
        payBtns[i].name = res[i].Picklist_ID || "";
      }
    }
  };

  makeCashfreePayment = async (e) => {
    var PaymentAmount = e.target.value;
    var Picklist_ID = e.target.name;

    const dropConfig = {
      components: ["order-details", "card", "netbanking", "app", "upi"],
      onSuccess: this.cashfreePaymentSuccess,
      onFailure: this.cashfreePaymentFailure,
    };

    await new Promise((resolve) => {
      $.ajax({
        url: baseURL + "api/CashfreePayments/createOrder",
        type: "POST",
        data: {
          Vendor_ID: "null",
          Amount: PaymentAmount,
          Payment_Type: "Sponsored Payment",
          Picklist_ID: Picklist_ID,
        },
        success: (result) => {
          try {
            const responseObj = typeof result === 'string' ? JSON.parse(result) : result;
            const paymentSessionId = responseObj["payment_session_id"];
            const mode = responseObj["environment"] || "production";

            const cashfree = Cashfree({
              mode: mode
            });

            cashfree.checkout({
              paymentSessionId: paymentSessionId,
              redirectTarget: "_self"
            });
            resolve();
          } catch (e) {
            console.error("Failed to parse Cashfree response:", result);
            alert("Error initializing payment: " + result);
            resolve();
          }
        },
        error: (xhr, status, error) => {
          console.error("Cashfree API Error:", xhr.responseText);
          alert("Payment Error: " + (xhr.responseJSON?.Msg || "Unknown error occurred"));
          resolve();
        },
      });
    });
  };

  cashfreePaymentSuccess = () => {};

  cashfreePaymentFailure = () => {};

  checkIfSubscriptionExpiring = (res) => {
    $.ajax({
      type: "POST",
      url: baseURL + "api/AmazonSesSmtp/sendVendorSubscriptionExpiringEmail",

      headers: { Authorization: X_API_KEY },
      success: (result) => {
        // result = JSON.parse(result);
      },
    });
  };
}

